import { Box } from '@mui/material';
import { LwButton } from 'redesign';
import { IconApproved, IconCancel } from 'assets/img';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useEditDocumentFormActions } from './hooks/use-edit-document-form-actions/use-edit-document-form-actions';
import { EditDocumentFormData } from '../edit-document-form-content/edit-document-content.types';

export const EditDocumentFormToolbox = () => {
  const { t } = useTranslation(['web-common', 'hq-screen-specific']);
  const formMethods = useFormContext<EditDocumentFormData>();
  const { handleEditDocument, handleCancel } = useEditDocumentFormActions();

  const handleFormSubmit = () => {
    formMethods.handleSubmit(handleEditDocument)();
  };

  return (
    <>
      <Box>
        <LwButton
          type="submit"
          iconColorMode="stroke"
          color="primary"
          startIcon={<IconApproved />}
          onClick={handleFormSubmit}
          disabled={formMethods.formState.isSubmitting}
        >
          {t('buttons.submit', { ns: 'web-common' })}
        </LwButton>
      </Box>
      <Box>
        <LwButton
          onClick={handleCancel}
          iconColorMode="fill"
          color="secondary"
          startIcon={<IconCancel />}
        >
          {t('buttons.cancel', { ns: 'web-common' })}
        </LwButton>
      </Box>
    </>
  );
};
